import { handleActions } from "redux-actions";
import { LIFECYCLE_SCRIPTS } from "constants/action-types";
import { fetchActions, initialBaseState, IFetchStoreState } from "./base-reducers";
import { ILifecycleScript } from "components/lifecycle-scripts/lifecycle-scripts-types";

export const lifecycleScripts = handleActions<IFetchStoreState<ILifecycleScript[]>>(
    {
        ...fetchActions(LIFECYCLE_SCRIPTS.FETCH),
    } as any,
    initialBaseState
);
